import spacing from '../spacing';

export default {
  root: {
    '& > *:not(:last-child)': {
      marginBottom: spacing(0.5),
    },
  },
};
